// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2wvGl","icon":"SortAdornment_icon__qhfX1","up":"SortAdornment_up__EWiVA","down":"SortAdornment_down__10pEr","active":"SortAdornment_active__1Ua6d"};